import * as types from "../actions/actionType";
import initialState from "./initialState";

const formReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SET_FORMDATA:
      return {
        ...state,
        data: action.payload
      }
    case types.SET_ERR:
      return {
        ...state,
        error: action.payload
      }
    case types.SET_SUCCESS:
      return {
        ...state,
        success: action.payload
      }
    default:
      return state;
  }
};

export default formReducer;
